import type React from 'react';

import type { EventId } from '@vlabs/api/luna-api/model/EventId';
import { EventApiProvider } from '@vlabs/monokit/entities/events/api';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import {
  AllMatchesPoint,
  EventDetailsInfo,
  EventDetection,
  EventMediaViewer,
  TopMatchCardPoint,
} from '@vlabs/monokit/widgets';
import { useParams } from 'react-router-dom';

import st from './EventDetailsPage.module.sass';
import { EventDetailsPageHeader } from './header/EventDetailsPageHeader';
import { useEventDetailsPageTranslation } from './i18n';

function EventDetailsPage(): React.JSX.Element {
  const { t } = useEventDetailsPageTranslation();
  const { eventId } = useParams<{ eventId: EventId }>();

  return (
    <EventApiProvider>
      <Page>
        <PageContent>
          <EventDetailsPageHeader />
          <div className={st.Root}>
            <div className={st.Info}>
              <EventDetailsInfo eventId={eventId} />
            </div>
            <div className={st.MatchesContainer}>
              <EventMediaViewer eventId={eventId} />

              <div className={st.Section}>
                <h5>{t('title', { context: 'detection' })}</h5>
                <EventDetection
                  className={st.EventDetection}
                  eventId={eventId}
                />
              </div>

              <TopMatchCardPoint eventId={eventId} />
              <AllMatchesPoint eventId={eventId} />
            </div>
          </div>
        </PageContent>
      </Page>
    </EventApiProvider>
  );
}

export { EventDetailsPage };
